

export type EndpointType = 'SERIAL' | 'BOXID' | 'CUSTOM';

export interface OcppPlatformProfile {
  id: string;
  name: string;

  // Para construir la URL
  baseUrl: string;   // ej: "wss://ocpp.monta.app"
  port?: number;     // si es 443 puedes omitirlo al construir

  endpoint: {
    type: EndpointType;
    requiredFromUser: boolean;
    requiredPortInUrl: boolean;
    helpText?: string;
    helpTextVar?: string;
  };

  // Solo para UX
  popular?: boolean;
  exampleUrl: string;
}




export const OCPP_TOP_PROFILES: OcppPlatformProfile[] = [


    {
    id: 'etecnic',
    name: 'Etecnic',
    baseUrl: 'ws://ocpp.etecnic.net',
    port: 52106,
    endpoint: {
      type: 'SERIAL',
      requiredFromUser: false,
      requiredPortInUrl: true,
      helpText: 'Se usa el número de serie del cargador.'
    },
    popular: true,
    exampleUrl: 'ws://ocpp.etecnic.net:52106/{SERIAL}'
  },
    {
    id: 'monta',
    name: 'Monta',
    baseUrl: 'ws://ocpp.monta.app',
    port: 80,
    endpoint: {
      type: 'SERIAL',
      requiredFromUser: false,
      requiredPortInUrl: false,
      helpText: 'Se usa el número de serie del cargador.'
    },
    popular: true,
    exampleUrl: 'ws://ocpp.monta.app/{SERIAL}'
  },
  {
    id: 'nexxtmove',
    name: 'Nexxtmove',
    baseUrl: 'ws://nexxtmove.me/b2bevocpp/ocpp-j',
    port: 80,
    endpoint: {
      type: 'SERIAL',
      requiredFromUser: false,
      requiredPortInUrl: false,
      helpText: 'Se usa el número de serie del cargador.'
    },
    popular: true,
    exampleUrl: 'ws://nexxtmove.me/b2bevocpp/ocpp-j/{SERIAL}'
  },
  {
    id: 'e-flux',
    name: 'e-flux',
    baseUrl: 'ws://ocpp.e-flux.nl/1.6/e-flux',
    port: 80,
    endpoint: {
      type: 'SERIAL',
      requiredFromUser: false,
      requiredPortInUrl: false,
      helpText: 'Se usa el número de serie del cargador.'
    },
    popular: false,
    exampleUrl: 'ws://ocpp.e-flux.nl/1.6/e-flux/{SERIAL}'
  },
    {
    id: 'powerstation',
    name: 'Powerstation',
    baseUrl: 'ws://ocpp.e-flux.nl/1.6/powerstation',
    port: 80,
    endpoint: {
      type: 'SERIAL',
      requiredFromUser: false,
      requiredPortInUrl: false,
      helpText: 'Se usa el número de serie del cargador.'
    },
    popular: false,
    exampleUrl: 'ws://ocpp.e-flux.nl/1.6/powerstation/{SERIAL}'
  },
  {
    id: 'electromaps',
    name: 'Electromaps',
    baseUrl: 'ws://manager.electromaps.com:8080/ocpp/websocket/CentralSystemService',
    port: 8080,
    endpoint: {
      type: 'BOXID',
      requiredFromUser: true,
      requiredPortInUrl: false,
      helpText: ' el identificador del endpoint proporcionado por Electromaps.',
      helpTextVar: 'helpTextOcpp'
    },
    popular: true,
    exampleUrl: 'ws://manager.electromaps.com:8080/ocpp/websocket/CentralSystemService/{endpoint}'
  },
    {
    id: 'placeToPlug',
    name: 'PlaceToPlug',
    baseUrl: 'ws://ocpp.placetoplug.com/16-json',
    port: 80,
    endpoint: {
      type: 'BOXID',
      requiredFromUser: true,
      requiredPortInUrl: false,
      helpText: 'Introduce el identificador del endpoint proporcionado por PlaceToPlug.',
      helpTextVar: 'helpTextOcpp'
        },
    popular: true,
    exampleUrl: 'ws://ocpp.placetoplug.com/16-json/{endpoint}'
  },
  {
    id: 'zunder',
    name: 'Zunder',
    baseUrl: 'ws://ocpp-generic-2.zunder.com:80/ocpp/1.6/jws/',
    port: 80,
    endpoint: {
      type: 'BOXID',
      requiredFromUser: true,
      requiredPortInUrl: false,
      helpText: 'Introduce el identificador del endpoint proporcionado por Zunder.',
      helpTextVar: 'helpTextOcpp'
    },
    popular: true,
    exampleUrl: 'ws://ocpp-generic-2.zunder.com:80/ocpp/1.6/jws/{endpoint}'
  },

  {
    id: 'custom', // Siempre debe ser el último
    name: 'Personalizado',
    baseUrl: '',
    endpoint: {
      type: 'CUSTOM',
      requiredFromUser: true,
      requiredPortInUrl: true,
      helpText: 'Introduce la URL completa del endpoint OCPP proporcionado por tu plataforma.'
    },
    exampleUrl: 'wss://my-ocpp-platform.com/{endpoint}'
  }
];
